import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-launcher-patient',
  templateUrl: './chat-launcher-patient.component.html',
  styleUrls: ['./chat-launcher-patient.component.css']
})
export class ChatLauncherPatientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
